import { Link } from 'react-router-dom';

export default function SpecialtyPharmacy() {
  const specialtyTypes = [
    {
      title: '専門医療機関連携薬局',
      description: 'がん、精神科、小児科等の専門医療に特化した薬局',
      icon: 'ri-hospital-line',
      color: 'bg-red-50 text-red-600',
      features: [
        '専門医療機関との密接な連携',
        '高度な薬学的管理',
        '専門薬剤師による服薬指導',
        '特殊な医薬品の調剤・管理'
      ],
      specialties: ['がん薬物療法', '精神科薬物療法', '小児薬物療法', '腎疾患薬物療法']
    },
    {
      title: '地域連携薬局',
      description: '地域の医療機関や介護施設と連携し、在宅医療を支援',
      icon: 'ri-community-line',
      color: 'bg-blue-50 text-blue-600',
      features: [
        '24時間対応体制',
        '在宅患者訪問薬剤管理',
        '多職種連携',
        '地域医療ネットワーク参加'
      ],
      specialties: ['在宅医療', '介護連携', '多職種チーム医療', '地域包括ケア']
    },
    {
      title: '健康サポート薬局',
      description: '健康の維持・増進を積極的に支援する薬局',
      icon: 'ri-heart-pulse-line',
      color: 'bg-green-50 text-green-600',
      features: [
        '健康相談・健康づくり支援',
        '要指導医薬品等の適正使用',
        '医療機関等との連携',
        '地域住民への情報発信'
      ],
      specialties: ['健康相談', 'セルフメディケーション', '生活習慣病予防', '介護予防']
    }
  ];

  const services = [
    {
      title: '高度薬学管理',
      description: '専門性の高い薬物療法における包括的な薬学的管理',
      icon: 'ri-microscope-line',
      details: [
        'TDM（薬物血中濃度モニタリング）',
        '副作用モニタリング',
        '薬物相互作用の評価',
        '投与設計の最適化'
      ]
    },
    {
      title: '無菌調剤',
      description: '注射薬の無菌調製による安全で正確な薬物療法の提供',
      icon: 'ri-test-tube-line',
      details: [
        'クリーンベンチでの調製',
        '抗がん剤の安全調製',
        '高カロリー輸液の調製',
        '品質管理・衛生管理'
      ]
    },
    {
      title: '在宅医療支援',
      description: '在宅患者への訪問薬剤管理指導と医療チーム連携',
      icon: 'ri-home-heart-line',
      details: [
        '在宅患者訪問薬剤管理指導',
        '服薬支援・薬剤管理',
        '医療機器の提供・指導',
        '多職種との情報共有'
      ]
    },
    {
      title: '専門外来連携',
      description: '専門外来との密接な連携による継続的な薬物療法支援',
      icon: 'ri-links-line',
      details: [
        '専門医との情報共有',
        '治療プロトコールの理解',
        '患者教育・指導',
        '副作用対策の提案'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-50 to-blue-50 py-16">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/d167625e3ca2077e03e479fad0085ed9.jpg"
            alt="専門薬局サービス"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">
            認定薬局
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            高度な専門性と地域連携により、質の高い薬物療法と健康サポートを提供します
          </p>
        </div>
      </section>

      {/* Specialty Types Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">認定薬局の種類</h2>
            <p className="text-xl text-gray-600">それぞれの特色と専門分野</p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {specialtyTypes.map((type, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100">
                <div className={`w-16 h-16 rounded-xl ${type.color} flex items-center justify-center mb-6`}>
                  <i className={`${type.icon} text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{type.title}</h3>
                <p className="text-gray-600 mb-6">{type.description}</p>
                
                <div className="mb-6">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3">主な機能:</h4>
                  <ul className="space-y-2">
                    {type.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-gray-700 text-sm">
                        <i className="ri-check-line text-teal-600 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h4 className="text-sm font-semibold text-gray-700 mb-2">専門分野:</h4>
                  <div className="flex flex-wrap gap-1">
                    {type.specialties.map((specialty, idx) => (
                      <span key={idx} className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full">
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">専門サービス</h2>
            <p className="text-xl text-gray-600">高度な専門性を活かしたサービス</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100">
                <div className="w-12 h-12 bg-red-50 text-red-600 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                <ul className="space-y-2">
                  {service.details.map((detail, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-arrow-right-s-line text-red-600 mr-2"></i>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">専門薬局のメリット</h2>
            <p className="text-xl text-gray-600">患者さんにとっての価値</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl shadow-lg p-6 text-center border border-gray-100">
              <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">専門性の高いケア</h3>
              <p className="text-gray-600 text-sm">専門薬剤師による高度な薬学的管理</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center border border-gray-100">
              <div className="w-12 h-12 bg-green-50 text-green-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">チーム医療</h3>
              <p className="text-gray-600 text-sm">医師・看護師等との密接な連携</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center border border-gray-100">
              <div className="w-12 h-12 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">安全性の向上</h3>
              <p className="text-gray-600 text-sm">専門知識による副作用の早期発見</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center border border-gray-100">
              <div className="w-12 h-12 bg-orange-50 text-orange-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">継続的サポート</h3>
              <p className="text-gray-600 text-sm">長期にわたる一貫した薬物療法管理</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/self-care" className="hover:text-white cursor-pointer">セルフケア</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/pharmacist-resources" className="hover:text-white cursor-pointer">専門リソース</Link></li>
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
